<aside class="al-sidebar" sidebarResize>
  <ba-menu [menuHeight]="menuHeight"
           [sidebarCollapsed]="isMenuCollapsed"
           (expandMenu)="menuExpand()"
           id="ba-menu"></ba-menu>
</aside>
